import { render } from "./ilos-view-component.vue?vue&type=template&id=abe299d6&scoped=true&ts=true"
import script from "./ilos-view-component.vue?vue&type=script&lang=ts"
export * from "./ilos-view-component.vue?vue&type=script&lang=ts"

import "./ilos-view-component.vue?vue&type=style&index=0&id=abe299d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe299d6"]])

export default __exports__